import { NavItem as NavItemType, useMainNav } from './main-nav-context';
import { useDefaultLayoutState } from '@/app/store';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { Box, Link, Tooltip } from '@chakra-ui/react';

const NavItem = (props: NavItemType) => {
  const { isSiderCollapsed } = useDefaultLayoutState();
  const { pathname } = useLocation();
  const isActive = pathname.toLowerCase().startsWith(props.to);

  return (
    <Tooltip label={isSiderCollapsed ? props.title : ''} placement='right'>
      <Link
        as={ReactRouterLink}
        to={props.to}
        display='flex'
        bg={isActive ? 'primary' : 'white'}
        color={isActive ? 'white' : 'primary'}
        _focus={{ boxShadow: 'unset' }}
        _hover={{
          bg: isActive ? 'primary' : 'gray.200',
          color: isActive ? 'white' : 'black',
        }}
        alignItems='center'
        justifyContent={isSiderCollapsed ? 'center' : 'start'}
        py={3}
        gap={3}
        px={isSiderCollapsed ? 0 : 6}
      >
        {props.icon}
        {!isSiderCollapsed && <>{props.title}</>}
      </Link>
    </Tooltip>
  );
};

export const MainNav = () => {
  const { navItems } = useMainNav();

  return (
    <Box h='100%' className='main-nav-container'>
      {navItems.map((navItem) => {
        return <NavItem {...navItem} key={navItem.key} />;
      })}
    </Box>
  );
};
